'use es6';

export const betaLocales = {
  ko: {
    language: 'ko',
    beta: true,
    defaultLocale: 'ko',
    availableLocale: ['ko']
  },
  th: {
    language: 'th',
    beta: true,
    defaultLocale: 'th',
    availableLocale: ['th']
  },
  'zh-cn': {
    language: 'zh-cn',
    beta: true,
    defaultLocale: 'zh-cn',
    availableLocale: ['zh-cn']
  }
};
export const betaPublicLocales = {
  'pt-pt': {
    language: 'pt-pt',
    beta: true,
    defaultLocale: 'pt-pt',
    availableLocale: ['pt-pt']
  }
};